export default __webpack_public_path__ + "static/media/BingoCardSelected.b776d1f3.svg";